<template>
  <div class="toast">
    <div class="question">
      <div class="text-t">您的基本信息</div>
      <div class="input-content">
        <div class="item-title">您的电话</div>
        <input
          type="number"
          v-model="questionData.phone"
          placeholder="输入您的手机号码"
        />
      </div>
      <div class="image-container">
        <img class="image" :src="imageData" alt="" />
        <div class="change-image" @click="getImage">换一张？</div>
      </div>
      <div class="input-content">
        <div class="item-title">图片验证码</div>
        <input
          type="text"
          v-model="questionData.yzm"
          maxlength="4"
          placeholder="请输入"
        />
      </div>
      <div class="input-content">
        <div class="item-title">验证码</div>
        <input
          type="number"
          v-model="questionData.code"
          maxlength="6"
          placeholder="输入验证码"
        />
        <div class="send-code" @click="bindSendCode">{{
          codeTime ? codeTime + '秒' : '发送验证码'
        }}</div>
      </div>
    </div>
    <div class="btn-content">
      <div class="btn-item" @click="bindCancel">取消</div>
      <div class="btn-item btn-item-confirm" @click="bindSubmit">购买</div>
    </div>
  </div>
</template>
<script>
import { shopBaseUrl } from '../data.js'
export default {
  data() {
    return {
      lossPosition: ['腰', '肚子', '手臂', '腿'],
      imageToken: '',
      imageData: '',
      questionData: {
        phone: '',
        code: '',
        yzm: '' //图片验证码
      },
      codeTime: 0
    }
  },
  watch: {
    questionData: {
      deep: true,
      handler(data) {
        /* 处理ios复制两次的问题 */
        if (data.code.length > 6) {
          this.questionData.code = this.questionData.code.slice(0, 6)
        }
      }
    }
  },
  created() {
    this.getImage()
  },
  methods: {
    getImage() {
      let params = {
        type: 'login',
        company_id: 1
      }
      this.$http
        .commonGet(shopBaseUrl + '/api/h5app/wxapp/member/image/code', params)
        .then((res) => {
          res = res.data
          if (res.data) {
            this.imageToken = res.data.imageToken
            this.imageData = res.data.imageData
          } else {
            this.$toast('未获取到图片验证码')
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    bindSelect(item) {
      this.questionData.body_part = item
    },
    checkParams() {
      if (!this.questionData.phone) {
        this.$toast('请输入您的电话')
        return false
      }
      if (this.questionData.phone.length != 11) {
        this.$toast('电话号码必须为11位')
        return false
      }
      if (!this.questionData.code) {
        this.$toast('验证码不能为空')
        return false
      }
      return true
    },
    bindSendCode() {
      if (this.codeTime) {
        return
      } else if (!this.questionData.phone) {
        this.$toast('请输入您的电话')
        return
      } else if (this.questionData.phone.length != 11) {
        this.$toast('电话号码必须为11位')
        return
      } else if (!this.questionData.yzm.length) {
        this.$toast('请输入图片验证码')
        return
      }
      let params = {
        mobile: this.questionData.phone,
        type: 'login',
        token: this.imageToken,
        yzm: this.questionData.yzm
      }
      this.$http
        .commonGet(shopBaseUrl + '/api/h5app/wxapp/member/sms/code', params)
        .then((res) => {
          res = res.data
          if (!res.data.status_code) {
            this.$toast('发送成功')
            this.codeTime = 60
            this.timer = setInterval(() => {
              this.codeTime--
              if (this.codeTime <= 0) {
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$toast(res.data.message)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    bindCancel() {
      this.$emit('cancel')
    },
    bindSubmit() {
      if (!this.checkParams()) {
        return
      }
      this.$emit('submit', this.questionData)
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  width: 283px;
  background: #f7f7f7;
  border-radius: 8px;
  overflow: hidden;

  .image-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .image {
      border-radius: 4px;
      overflow: hidden;
      width: 150px;
    }

    .change-image {
      white-space: nowrap;
      font-weight: 600;
      color: #4a3d6b;
      line-height: 20px;
    }
  }

  .question {
    padding: 20px 20px 24px;

    .text-t {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(74, 61, 107, 0.5);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .radio-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .radio-item {
        position: relative;
        width: 115px;
        height: 30px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid #f1f1f1;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        margin-right: 13px;
        margin-bottom: 8px;

        .iconfont {
          position: absolute;
          right: 7px;
          top: 50%;
          transform: translate(0%, -50%);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #786aff;
          color: #fff;
          font-weight: 600;
        }
      }

      .radio-item:nth-child(2n) {
        margin-right: 0px;
      }

      .radio-item-active {
        border: 2px solid #786aff;
      }
    }

    .input-content {
      height: 36px;
      background: #ffffff;
      border-radius: 18px;
      border: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      padding: 0px 18px;
      margin-bottom: 16px;

      .item-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.7);
        line-height: 17px;
        margin-right: 17px;
      }

      input {
        padding: 0;
        border: none;
        outline: none;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        line-height: 30px;
      }

      input::-webkit-input-placeholder {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.3);
        line-height: 17px;
      }

      .item-unit {
        margin-left: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.7);
        line-height: 17px;
      }

      .send-code {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        line-height: 17px;
      }
    }
  }

  .btn-content {
    display: flex;
    align-items: center;

    .btn-item {
      width: 50%;
      height: 46px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #f1f1f1;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 46px;
      text-align: center;
    }

    .btn-item-confirm {
      background: #786aff;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
